import type { TranslationCatalog } from "../TranslationManager";

export const zh: TranslationCatalog = {
  "labels.cardNumber": "卡号",
  "labels.expirationDate": "有效期",
  "labels.cvc": "安全码",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "您的卡号无效。",
  "errors.invalidExpiryDate": "您的卡片有效期无效。",
  "errors.invalidCvc": "您的卡片安全码无效。",
  "errors.incompleteCardNumber": "您的卡号不完整。",
  "errors.incompleteExpiryDate": "您的卡片有效期不完整。",
  "errors.incompleteCvc": "您的卡片安全码不完整。",
  "errors.expiredCard": "您的卡片已过期。",
  "aria.cardNumber": "卡号",
  "aria.expirationDate": "有效期",
  "aria.cvc": "安全码",
  "aria.cardInput": "卡片信息",
};
